import React, { ComponentType, useEffect } from "react";
import ExistingCustomerSearch from "./index";
import { IExistingCustomerSearch } from './types'
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import { CustomerMode } from 'shared-types/SharedTypes';

const containerPropsKeys: string[] = keys<IExistingCustomerSearch>();

const ThemeWrap = function(props: IExistingCustomerSearch) {
  const { setView, customer, setCustomer, customers, setCustomers, inputOnFocus,
  handleViewCustomer, setSkipCustomerDuplicationCheck, handleEditCustomer, errors, setErrors, country, searchResultStatus, view
  } = props
  useEffect(() => {
    setSkipCustomerDuplicationCheck(false);
  }, []);

  return ReactUtilsService.containerWrap(
    <ExistingCustomerSearch
      setView={setView}
      customer={customer}
      setCustomer={setCustomer}
      customers={customers}
      setCustomers={setCustomers}
      inputOnFocus={inputOnFocus}
      handleViewCustomer={handleViewCustomer}
      handleEditCustomer={handleEditCustomer}
      errors={errors}
      setErrors={setErrors}
      country={country}
      searchResultStatus={searchResultStatus}
      view={CustomerMode.SEARCH}
    />, 'ExistingCustomerSearch'
  );
}

const R2AExistingCustomerSearch: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
];

export default R2AExistingCustomerSearch
